import { useEffect } from "react";

import {
    useExperimentExposure,
    experiments
} from "@/utils/experiment/index.ts";

import {
    UniformEntryPage,
    UniformEntryPageProps
} from "./uniform-entry-page.tsx";

export const UniformConfluencePricingEntryPage = (
    props: UniformEntryPageProps
) => {
    const [hasFired, fireExposure] = useExperimentExposure(
        experiments.confluencePricingPageWaeMigration
    );

    useEffect(() => {
        if (!hasFired) {
            fireExposure();
        }
    }, [hasFired, fireExposure]);

    return <UniformEntryPage {...props} />;
};
